import { Delete as DeleteIcon } from '@mui/icons-material';
import {
  Card,
  CardHeader,
  IconButton,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { MissingPerson } from './MissingPerson';
import { RiskAvatar } from './MissingPerson/RiskAvatar';
import { useNichePerson } from '@/hooks';
import { DetailsPanel } from '@/components/controls';

export function SharedMissingPerson({
  personId,
  reason,
  onShareClick,
  onShowMapClick,
  onDeleteClick,
}) {
  const {
    query: { data: subject, isFetching },
  } = useNichePerson(personId, { addresses: true });

  if (isFetching) {
    return <Skeleton variant="rounded" sx={{ minWidth: 240 }} height={240} />;
  }

  return subject ? (
    <MissingPerson
      missingPerson={{ subject }}
      onShowMapClick={onShowMapClick}
      onShareClick={onShareClick}
      reason={reason}
    />
  ) : (
    <Card variant="outlined" sx={{ minWidth: 240 }}>
      <CardHeader
        avatar={<RiskAvatar />}
        action={
          <Tooltip title="Delete">
            <IconButton size="small" color="error" onClick={onDeleteClick}>
              <DeleteIcon sx={{ fontSize: 'inherit' }} />
            </IconButton>
          </Tooltip>
        }
        title="Not Found"
        sx={{ textTransform: 'capitalize' }}
      />

      <Stack spacing={1} sx={{ p: 1 }}>
        <Typography variant="body2" sx={{ p: 0.5 }}>
          This person cannot be found.
        </Typography>
        <DetailsPanel
          entries={[
            {
              label: 'Person ID',
              value: personId,
            },
            {
              label: 'Reason',
              value: reason,
            },
          ]}
        />
      </Stack>
    </Card>
  );
}
